import React, { useContext } from "react";
import "./DashboardHeader.css";
import DashboardHeaderHamburger from "./dashboard_header/DashboardHeaderHamburger";
import UIContext from "../../contexts/ui/UIContext";

interface DashboardHeaderProps {
  onMenuClick: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ onMenuClick }) => {
  const uiContext = useContext(UIContext);

  return (
    <div className="dashboard-header">
      <DashboardHeaderHamburger onMenuClick={onMenuClick} />
      <div className="dashboard-header__mobile-title">
        {uiContext.pageTitle}
      </div>
    </div>
  );
};

export default DashboardHeader;
